import React from 'react'
import {
  Route,
  IndexRoute,
} from 'react-router'

/** Route pages */
import Populator from 'populators/Bank'

const Bank = (store) => {
  const Routes = () => (
    <Route path="banks" component={Populator.components.Home} name="Banks">
      <IndexRoute
        component={Populator.components.List}
        onEnter={() => Populator.populate.list(store)}
        name="List"
      />
      <Route
        path="add"
        component={Populator.components.Add}
        onEnter={() => Populator.populate.add(store)}
        name="Add"
      />
      <Route
        path=":id/edit"
        component={Populator.components.Edit}
        onEnter={next => Populator.populate.edit(store, next.params.id)}
        name="Edit"
      />
      <Route
        path=":id/remove"
        onEnter={next => Populator.populate.remove(store, next.params.id)}
        name="Remove"
      />
    </Route>
  )

  return Routes()
}

export default Bank
